<template>
	<div class="eil" role="alert">
		<div class="eil__title">Не удалось загрузить инстанс.</div>
		<div class="eil__description">Попробуйте обновить страницу.</div>
	</div>
</template>

<style scoped lang="scss">
.eil {
	padding: 24px;
	background: rgb(255, 255, 255);
	border-radius: 12px;
	box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.02);
	color: rgb(49, 49, 50);
	text-align: center;

	&__title {
		font-size: 24px;
		font-weight: 600;
	}

	&__description {
		margin-top: 12px;
		font-size: 16px;
	}

	@media screen and (max-width: 768px) {
		&__title {
			font-size: 22px;
		}
	}
}
</style>
